import { DashboardFormWrapper } from '../dashboard';
import { StoragePricingsPage } from './StoragePricingsComponents';
import { StoragePricingsAddHeader, StoragePricingsAddForm } from './StoragePricingsAddComponents';
import { RoleGuard } from '../../routes';

export const StoragePricingsAdd = () => {
  return (
    <RoleGuard
      roles={['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE']}
      redirectTo={'/dashboard/storage-pricing'}
    >
      <StoragePricingsPage>
        <StoragePricingsAddHeader />
        <DashboardFormWrapper flow={'row'}>
          <StoragePricingsAddForm />
          <StoragePricingsAddHeader showOnlySubmit />
        </DashboardFormWrapper>
      </StoragePricingsPage>
    </RoleGuard>
  );
};
